// src/Disclaimer.js

import React from 'react';

const Disclaimer = () => {
  return (
    <div className="disclaimer-page">
      <h1>Disclaimer</h1>
      <p>
        The information provided on [Your Website Name] is for general informational purposes only. All content on this site is provided in good faith; however, we make no guarantees about the accuracy or completeness of the information provided.
      </p>
      <h2>Third-Party Ads and Affiliate Links</h2>
      <p>
        We may include third-party advertisements and affiliate links on our website. Clicking on these links may lead you to third-party websites, which are not under our control. We are not responsible for the content or privacy practices of these sites.
      </p>
      <h2>Advice Disclaimer</h2>
      <p>
        Any advice or recommendations offered on this website should be taken at your own risk. We are not liable for any outcomes based on the information provided.
      </p>
      <h2>Updates to This Disclaimer</h2>
      <p>
        We reserve the right to update this disclaimer at any time. If we make changes, they will be reflected on this page.
      </p>
    </div>
  );
};

export default Disclaimer;
